import React, { useEffect, useState } from "react";
import Navbar from "./Components/nav";
import Intro from "./Components/intro";
import About from "./Components/about";
import Experience from "./Components/experience";
import Work from "./Components/work";
import Contact from "./Components/contact";
import Footer from "./Components/footer";
import Loader from "./Components/loader";
import BackToTop from "./Components/backToTop";

function App() {
  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    document.title = "Sirisha Lokanath Raju";

    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
      window.scrollTo({ top: 0, behavior: "auto" });
    }

    const timer = setTimeout(() => setAppReady(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="noise" />

      {!appReady && <Loader />}

      {appReady && (
        <div>
          <Navbar />
          <Intro />
          <About />
          <Experience />
          <Work />
          <Contact />
          <Footer />
          <BackToTop />
        </div>
      )}
    </>
  );
}

export default App;
